import React from "react";
import { ShieldCheck } from "lucide-react";
import DataPrivacyContents from "./components/DataPrivacyContents";
import FullHeaderComponent from "../components/FullHeaderComponent";

const DataPrivacyPolicy = () => {
  return (
    <div className="flex flex-col -mx-3 sm:-mx-4 md:-mx-6 -mt-3 sm:-mt-4 md:-mt-6">
      <FullHeaderComponent
        icon={ShieldCheck}
        title="Work-from-Home, Data Privacy & IT Use Policy"
        subtitle="Hyvid Philippines · Owner: People & Culture · Review: Annually"
        hyvidScope="Applies to: All Hyvid Philippines employees"
        workArrangement="Remote / work-from-home"
        reviewTime="Annually"
      />
      <div>
        <DataPrivacyContents/>
      </div>
    </div>
  );
};

export default DataPrivacyPolicy;